import { render, staticRenderFns } from "./ContractComp.vue?vue&type=template&id=08154e30&scoped=true"
import script from "./ContractComp.vue?vue&type=script&lang=js"
export * from "./ContractComp.vue?vue&type=script&lang=js"
import style0 from "./ContractComp.vue?vue&type=style&index=0&id=08154e30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08154e30",
  null
  
)

export default component.exports